/**
 * 带有复选框的按钮
 * 使用方式 ↓
 * import CheckBoxButton from '@/components/CheckBoxButton
 * checked: true: 全选; false：取消全选; indeterminate： 部分选中
 * <CheckBoxButton checked={true | false | indeterminate}> test </CheckBoxButton>
 */
import React from 'react';
import { Checkbox } from '@shopify/polaris';

const CheckBoxButton = (props) => {
	return (
		<div className="Polaris-ButtonGroup Polaris-ButtonGroup--segmented">
			<div className="Polaris-ButtonGroup__Item" onClick={props.onChange}>
				<div className="Polaris-CheckableButton">
					<Checkbox labelHidden checked={props.checked} onChange={props.onChange} />
					<span className="Polaris-CheckableButton__Label">{props.children}</span>
				</div>
			</div>
		</div>
	)
}

export default CheckBoxButton
